export default __webpack_public_path__ + "static/media/Bloodweasel Boots.944d28ab.jpg";